"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c-1.8889 0-3.655.6548-4.951 1.955C5.749 5.2593 5 7.1344 5 9.4287c0 1.9544.9355 3.3302 1.8077 4.5673.8454 1.1961 1.9853 3.2986 2.4115 5.004h5.5616c.4263-1.7054 1.5661-3.8079 2.4115-5.0041C18.0645 12.7588 19 11.383 19 9.4286c0-2.2942-.7491-4.1693-2.0491-5.4735C15.655 2.6547 13.8889 2 12 2zM7 9.4286c0-1.848.594-3.1872 1.4656-4.0617C9.3413 4.4884 10.5752 4 12 4c1.4248 0 2.6587.4884 3.5344 1.367C16.4059 6.2413 17 7.5806 17 9.4285c0 1.2598-.5645 2.1698-1.4423 3.4148-.0507.072.0523-.0738 0 0-.7299 1.0305-1.754 2.4768-2.3085 4.1566h-2.4984c-.5545-1.6798-1.424-2.9074-2.1539-3.9379-.0522-.0738.0507.0718 0 0C7.7191 11.817 7 10.6884 7 9.4286z"
  }), _react.default.createElement("path", {
    d: "M14.7804 20h-5.557v2h5.557v-2z"
  })];
};

exports.default = _default;